import React, { useState } from "react";
import classnames from "classnames";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import useIsTouchDevice from "../../utils/useIsTouchDevice";
import * as styles from "./Email.module.css";

const ContactBanner = ({ subject, body, invert, alt }) => {
  const [visibleOptions, setVisibleOptions] = useState(false);
  const [copied, setCopied] = useState(false);
  const isTouchDevice = useIsTouchDevice();

  const classes = classnames(styles.emailSection, {
    [styles.visibleOptions]: visibleOptions
  });

  const buttonClasses = classnames(`button buttonCopy ${alt ? "buttonCopyAlt" : ""}`, {
    "buttonInvert": invert,
    "buttonFillAlt": copied,
    "buttonAlt": alt
  });

  const subjectLine = subject || "Let's work together";
  const bodyContent = body ? `&body=${encodeURIComponent(`${body}\n\n`)}` : "";

  const emailAddress = "hello@ustwo.com";
  const gmailLink = `https://mail.google.com/mail/?view=cm&to=${emailAddress}&su=${encodeURIComponent(subjectLine)}${bodyContent}`;
  const outlookLink = `https://outlook.live.com/owa/?path=/mail/action/compose&to=${encodeURIComponent(emailAddress)}`;

  return (
    <div
      className={styles.hitArea}
      onMouseEnter={() => !isTouchDevice && setVisibleOptions(true)}
      onMouseLeave={() => {
        !isTouchDevice && setVisibleOptions(false);
        setTimeout(() => setCopied(false), 500);
      }}
    >
      <div className={classes}>
        {isTouchDevice ? (
          <a
            href={`mailto:${emailAddress}`}
            className={`enormousText noMargin ${styles.email}`}
            data-cabin-event="Emailed-mobile"
            onClick={() => window.rybbit?.event("Emailed (mobile)")}
          >
            {emailAddress}
          </a>
        ) : (
          <span
            className={`enormousText noMargin ${styles.email}`}
          >
            {emailAddress}
          </span>
        )}
        {!isTouchDevice && (
          <div className={styles.optionsWrapper}>
            <CopyToClipboard
              text={emailAddress}
              onCopy={() => setCopied(true)}
              data-cabin-event="Emailed-copied"
              onClick={() => window.rybbit?.event("Emailed (copied)")}
            >
              <button className={buttonClasses}>
                {copied ? "Copied" : "Copy"}
              </button>
            </CopyToClipboard>
            <a
              href={gmailLink}
              target="_blank"
              rel="noopener noreferrer"
              className={`button ${invert ? "buttonInvert" : ""} ${alt ? "buttonAlt" : ""}`}
              data-cabin-event="Emailed-gmail"
              onClick={() => window.rybbit?.event("Emailed (clicked gmail)")}
            >
              Open in Gmail
            </a>
            <a
              href={outlookLink}
              target="_blank"
              rel="noopener noreferrer"
              className={`button ${invert ? "buttonInvert" : ""} ${alt ? "buttonAlt" : ""}`}
              data-cabin-event="Emailed-outlook"
              onClick={() => window.rybbit?.event("Emailed (clicked outlook)")}
            >
              Open in Outlook
            </a>
            
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactBanner;
